import { MicrophoneIcon } from "@heroicons/react/24/outline";
import { MicrophoneIcon as MicrophoneIconSolid } from "@heroicons/react/24/solid";
import PropTypes from "prop-types";

/** Video-call style mute / unmute mic toggle for dictation. */
const SpeechMicButton = ({
  isListening,
  isSupported,
  onClick,
  className = "",
  size = "md",
}) => {
  if (!isSupported) return null;

  const sizeClass =
    size === "sm"
      ? "h-7 w-7"
      : size === "lg"
        ? "h-10 w-10"
        : "h-9 w-9";
  const iconClass = size === "sm" ? "h-4 w-4" : size === "lg" ? "h-5 w-5" : "h-5 w-5";

  return (
    <button
      type="button"
      onClick={onClick}
      title={isListening ? "Mute microphone (stop dictation)" : "Unmute microphone (start dictation)"}
      aria-label={isListening ? "Mute microphone" : "Unmute microphone"}
      aria-pressed={isListening}
      className={`inline-flex ${sizeClass} shrink-0 items-center justify-center rounded-full border-2 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-1 ${
        isListening
          ? "border-red-500 bg-red-500 text-white shadow-md shadow-red-200 focus:ring-red-400 animate-pulse"
          : "border-gray-400 bg-white text-gray-600 hover:border-[#217E90] hover:bg-[#E9F5FE] hover:text-[#217E90] focus:ring-[#217E90]"
      } ${className}`}
    >
      {isListening ? (
        <MicrophoneIconSolid className={iconClass} aria-hidden />
      ) : (
        <span className={`relative inline-flex ${iconClass} items-center justify-center`} aria-hidden>
          <MicrophoneIcon className={iconClass} />
          <span className="pointer-events-none absolute left-1/2 top-1/2 h-[2px] w-5 -translate-x-1/2 -translate-y-1/2 rotate-45 rounded-full bg-current opacity-90" />
        </span>
      )}
    </button>
  );
};

SpeechMicButton.propTypes = {
  isListening: PropTypes.bool.isRequired,
  isSupported: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
  size: PropTypes.oneOf(["sm", "md", "lg"]),
};

export default SpeechMicButton;
